import { clamp } from 'lodash-es';
import React, { createContext, useContext } from 'react';
const MIN_PANE_WIDTH_PX = 320;
export const SPLIT_PANE_WIDTHS_KEY = 'pplx.split-pane.widths.v2';
export const SplitPaneContext = createContext({
    isOpen: false,
    isResponsiveOverlay: false,
    isPrimaryCollapsed: false,
    togglePrimaryCollapsed: () => { },
    setWidth: () => { },
    setMinimumPrimaryWidthPx: () => { },
    resizable: true,
    secondaryWidth: '0px',
    registerPrimaryElement: () => { },
    registerSecondaryElement: () => { },
    secondaryElementRef: { current: null },
    scrollableContainerRef: { current: null },
});
SplitPaneContext.displayName = 'SearchSideContainerContext';
export const useSplitPane = () => useContext(SplitPaneContext);
export const useSplitPaneInternal = () => useContext(SplitPaneContext);
export const clampPaneWidth = ({ widthPx, availableWidth, }) => clamp(widthPx, MIN_PANE_WIDTH_PX, Math.max(0, availableWidth / 2));
export const PRIMARY_WIDTH_VAR = '--split-pane-primary-width';
export const getSavedWidth = ({ widths, widthKey, resizable, }) => {
    if (!resizable)
        return undefined;
    const width = widths?.[widthKey];
    return typeof width === 'number' && Number.isFinite(width) ? width : undefined;
};
export function shouldUseSplitPaneOverlay({ availableWidthPx, minimumPrimaryWidthPx, }) {
    if (minimumPrimaryWidthPx <= 0)
        return false;
    if (availableWidthPx <= 0)
        return true;
    return availableWidthPx < minimumPrimaryWidthPx + MIN_PANE_WIDTH_PX;
}
const getAnchorWidth = (widthPx, minimumPrimaryWidthPx) => {
    const maximumWidth = minimumPrimaryWidthPx > 0
        ? `calc(var(${PRIMARY_WIDTH_VAR}, 100vw) - ${minimumPrimaryWidthPx}px)`
        : `calc(var(${PRIMARY_WIDTH_VAR}, 100vw) / 2)`;
    return `min(max(${MIN_PANE_WIDTH_PX}px, ${widthPx}px), ${maximumWidth})`;
};
export const getSecondaryWidth = ({ widthPx, widthAnchor, minimumPrimaryWidthPx = 0, }) => {
    const width = getAnchorWidth(widthPx, widthAnchor === 'secondary' ? minimumPrimaryWidthPx : 0);
    if (widthAnchor === 'primary') {
        const secondaryWidth = `calc(var(${PRIMARY_WIDTH_VAR}, 100vw) - ${width})`;
        if (minimumPrimaryWidthPx <= 0)
            return secondaryWidth;
        return `min(${secondaryWidth}, calc(var(${PRIMARY_WIDTH_VAR}, 100vw) - ${minimumPrimaryWidthPx}px))`;
    }
    return width;
};
//# sourceMappingURL=SplitPaneShared.js.map